import React from "react";
import "./Trust.css";
import { Handshake, Users } from "lucide-react";

import byteskillsLogo from "../assets/assets/byteskills.png";
import geoinfyLogo from "../assets/assets/geo.jpg";
import pinkmoonLogo from "../assets/assets/pinkmoonn.jpg";
import brainwavesLogo from "../assets/assets/nuhvin.png";
import vedaLogo from "../assets/assets/veda.jpg";
import curioLogo from "../assets/assets/curio.avif";

const logos = [
  byteskillsLogo,
  geoinfyLogo,
  pinkmoonLogo,
  brainwavesLogo,
  vedaLogo,
  curioLogo,
];

const WhyChooseUs = () => {
  const currentYear = new Date().getFullYear();
  const yearsActive = Math.max(1, currentYear - 2022);

  return (
    <div className="why-section">
      {/* Header */}
      <div className="why-header">
        <h4 className="why-subtitle">🌐 Why Choose Us</h4>
        <h2 className="why-title">
          Trusted Technology Partner for Modern Enterprises
        </h2>
        <p className="why-desc">
          Experience how our AI-powered features simplify workflows, automate
          tasks, and help your team achieve more — so you can focus on growing
          your business.
        </p>
      </div>

      {/* GRID */}
      <div className="why-grid">
        {/* LEFT BIG IMAGE (spans 3 rows) */}
        <div className="why-image">
          <img src="/spacematter.png" alt="AI abstract" />
        </div>

        {/* CARD 1 */}
        <div className="why-card white">
          <h3>99%</h3>
          <h4>Client Satisfaction</h4>
          <p>
            We deliver transparency, timely execution, and measurable results.
          </p>
        </div>

        {/* CARD 2 */}
        <div className="why-card gradient">
          <h3>3x</h3>
          <h4>Operational Efficiency</h4>
          <p>Clients report a 3x boost in workflow speed.</p>
        </div>

        {/* CARD 3 */}
        <div className="why-card white1">
          <h3>12+</h3>
          <h4>AI Launches</h4>
          <p>100+ businesses launched using our AI expertise.</p>
        </div>

        {/* CARD 4 */}
        <div className="why-card dark">
          <h3>15+</h3>
          <h4>Long-Term Partners</h4>
          <div className="logo-row">
            {logos.map((logo, i) => (
              <img key={i} src={logo} alt="" />
            ))}
          </div>
          <p>50+ companies continue working with us long-term.</p>
        </div>

        {/* CARD 5 */}
        <div className="why-card long-term-commitment">
          <h3>
            <Handshake />
          </h3>
          <h4>Long Term Commitment</h4>
          <p>
            {yearsActive} + Years of running a profitable organization gives us a good sense
            of challenges that growing a business faces. We take pride running a
            sustainable business thats powered you
          </p>
        </div>

        {/* CARD 6 */}
        <div className="why-card long-term-philosophy">
          <h3>
            <Users />
          </h3>
          <h4>Customer First Philosophy</h4>
          <p>
            In all these Years , Its our customers trust and goodwill that has
            helped us establish a strong position in the market. No matter the
            size of your business, we are here to help you grow.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
